export default __webpack_public_path__ + "static/media/grade-graph.47deff71.png";